/* 🤖 this file was generated by svg-to-ts*/
export const icoApple: {
  name: 'apple';
  data: string;
} = {
  name: 'apple',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.762 7.001l.272.017c.644.03 2.31.265 3.47 1.998l-.197.126c-.523.358-1.892 1.48-1.875 3.588.03 3.041 2.538 4.265 2.568 4.275l-.092.286a9.77 9.77 0 01-1.061 2.168l-.126.19c-.823 1.248-1.854 2.33-3.183 2.35-1.329.03-1.597-.659-3.104-.659-1.517 0-2.082.608-3.342.659-1.299.05-2.181-1.162-3.014-2.38-1.696-2.488-2.995-7.07-1.25-10.152.863-1.53 2.589-2.419 4.264-2.449 1.27-.02 2.3.798 3.084.798.728 0 2.141-.85 3.586-.815zM15.94 2c.06 1-.34 2.37-1.04 3.217C14.21 6.074 13 6.5 12 6.5c0-1 .36-2.221 1-2.987C13.73 2.676 15 2 15.94 2z" fill="#909090"/></svg>`
};
